// Auth / session
export const REFRESH_TOKEN_STRING = "refresh_token";
export const ACCESS_TOKEN_STRING = "access_token";
export const LOGIN_SUCCESSFUL_STRING = "Login successful";
export const X_CLIENT_PUBLIC_IP = "X-Client-Public-IP";
export const UNIQUE_DEVICE_ID = "3b966673-4b34-4537-9dde-29585745ffc2";
export const UNIQUE_DEVICE_ID_HASH = "1aa513d5-3524-4ddb-b847-ef0c75d1bb1e";
export const LOGIN_SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

/** Client audience ID used in the JWT refresh token grant (matches mobile audienceId). */
export const AUDIENCE_ID = process.env.REACT_APP_AUDIENCE_ID ?? "";
